import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { createFuncao, deleteFuncao, readFuncao, updateFuncao } from '@/modules/structure/funcao/funcao.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface ReadFuncaoDto {
  id?: number;
  nome: string;
  editadoPor?: { id: number; username: string };
  editadoEm?: Date;
}

export default function FuncaoEditPage() {
  const { register, handleSubmit, reset, getValues } = useForm<ReadFuncaoDto>();
  const { setActions } = useBreadcrumbActions();
  const navigate = useNavigate();
  const params = useParams();
  const [modalExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Funcao_Criar, onClick: () => {} },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  useEffect(() => {
    if (id > 0)
      readFuncao({ id: id })
        .then((result) => {
          if (result)
            reset(result[0][0]);
        })
        .catch((res) => {
          toast.error(String(res));
        });
  }, []);

  const onSubmit: SubmitHandler<ReadFuncaoDto> = (data) => {
    setIsLoading(true);

    if (data.id) {
      updateFuncao(data as { id: number; nome: string })
        .then(() => {
          toast.success('Função Atualizada.');
          navigate(`${Links.Funcao_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setIsLoading(false));
    } else {
      createFuncao(data)
        .then(() => {
          toast.success('Função Cadastrada.');
          navigate(`${Links.Funcao_Index}`);
        })
        .catch((res) => {
          toast.error(String(res));
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    deleteFuncao(id)
      .then(() => {
        toast.warning('Função Removida.');
        navigate(`${Links.Funcao_Index}`);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Função</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="mb-3 col-md-12">
            <label htmlFor="nome" className="form-label">
              Nome:
            </label>
            <input
              id="nome"
              autoFocus={true}
              title="Nome"
              type="text"
              className="form-control"
              {...register('nome', { required: true })}
            />
          </div>

          <EditadoPorRodape
            dados={{
              editadoPor: { username: getValues().editadoPor?.username },
              editadoEm: getValues().editadoEm,
            }}
          />

          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modalExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.funcao}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}

